"use client";

import { useTheme } from "next-themes";

import { Icons } from "@cohub42/ui/components/icons";
import { Button } from "@cohub42/ui/components/ui/button";
import { cn } from "@cohub42/ui/lib/utils";

export default function ThemeToggle({ className }: { className?: string }) {
  const { setTheme, theme } = useTheme();
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className={cn(className)}
    >
      <Icons.sun className="rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Icons.moon className="absolute rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
